import React from 'react'
import { ShowDialogArgs } from 'store/notification'
import { Translation } from 'locale'

export type ModalComponent = JSX.Element
export { NotificationType } from 'store/notification'

export interface ClonedComponentByShowModal {
  onClose?: (result?: any) => void
}

export interface ModalConsumerProps {
  showModal: (modal: ModalComponent) => Promise<any>
  showDialog: (options: ShowDialogArgs) => Promise<Translation>
}

export const ModalContext = React.createContext<ModalConsumerProps>({
  showModal: () => {
    throw new Error('No ModalProvider is available')
  },
  showDialog: () => {
    throw new Error('No ModalProvider is available')
  }
})

export const useModal = () => React.useContext(ModalContext)
